import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Coach, CoachesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class CoachesDataService {

  private uri: string = `${environment.apiUrl}coaches`;
  private cacheKey: string = 'coaches.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getCoach(id: number): Observable<Coach|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getCoaches(parameters: {[param: string]: string | string[]}): Observable<CoachesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addCoach(data: Coach): Observable<Coach|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addCoaches(data: Coach[]): Observable<Coach[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateCoach(data: Coach): Observable<Coach|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateCoaches(data: Coach[]): Observable<Coach[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchCoach(data: Coach): Observable<Coach|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchCoaches(data: Coach[]): Observable<Coach[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteCoach(data: Coach): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteCoaches(data: Coach[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((coach) => {
      ids.push(coach.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
